import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProductType } from '../../../../models/product.model';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-layout-main',
  templateUrl: './layout-main.component.html',
  styleUrls: ['./layout-main.component.scss']
})
export class LayoutMainComponent {

  // protected readonly window = window;

  constructor(
      private _router: Router,
      @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  public goToUrl(url:string):void {
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
    // this.window.open(url, '_blank');
  }

  public goToOrderForm(productType:ProductType): void {
    this._router.navigate(['order', productType.toLowerCase()])
  }
}
